"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferActionAccount = exports.TransferActionAccessor = exports.DevestingActionAccount = exports.DevestingActionAccessor = exports.MultisigTokenAccount = exports.MultisigTokenAccessor = exports.MultisigAccount = exports.MultisigAccessor = void 0;
var spl_token_1 = require("@solana/spl-token");
var web3_js_1 = require("@solana/web3.js");
var borsh_1 = require("@solvei/borsh");
var schema_1 = require("@solvei/borsh/schema");
var accounts_1 = require("./accounts");
var models_devesting_1 = require("./models-devesting");
var utils_1 = require("./utils");
var MultisigAccessor = /** @class */ (function (_super) {
    __extends(MultisigAccessor, _super);
    function MultisigAccessor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accountConstructor = MultisigAccount;
        return _this;
    }
    MultisigAccessor.prototype.getSeed = function () {
        return (0, utils_1.getSeed)(this.context.programId.toBase58(), "Multisig", this.context.vestingName);
    };
    MultisigAccessor.prototype.deserialize = function (account) {
        return (0, borsh_1.deserialize)((0, schema_1.generateSchemas)([models_devesting_1.Multisig]), models_devesting_1.Multisig, account.data);
    };
    MultisigAccessor.prototype.getPublicKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, web3_js_1.PublicKey.createWithSeed(this.context.creator, this.getSeed(), this.context.programId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return MultisigAccessor;
}(accounts_1.VestingAccountAccessor));
exports.MultisigAccessor = MultisigAccessor;
var MultisigAccount = /** @class */ (function (_super) {
    __extends(MultisigAccount, _super);
    function MultisigAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createContext = { space: models_devesting_1.Multisig.space, owner: "program" };
        return _this;
    }
    MultisigAccount.prototype.getName = function () {
        return "Multisig Account";
    };
    return MultisigAccount;
}(accounts_1.AccountWithSeed));
exports.MultisigAccount = MultisigAccount;
var MultisigTokenAccessor = /** @class */ (function (_super) {
    __extends(MultisigTokenAccessor, _super);
    function MultisigTokenAccessor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultisigTokenAccessor.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pubkey, storage, data, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getPublicKey()];
                    case 1:
                        pubkey = _b.sent();
                        return [4 /*yield*/, this.context.connection.getAccountInfo(pubkey)];
                    case 2:
                        storage = _b.sent();
                        _a = storage;
                        if (!_a) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.deserialize(pubkey)];
                    case 3:
                        _a = (_b.sent());
                        _b.label = 4;
                    case 4:
                        data = _a;
                        return [2 /*return*/, new MultisigTokenAccount(this.context, [], data, storage, pubkey, this.getSeed())];
                }
            });
        });
    };
    MultisigTokenAccessor.prototype.getSeed = function () {
        return (0, utils_1.getSeed)(this.context.programId.toBase58(), "MultisigToken", this.context.vestingName);
    };
    MultisigTokenAccessor.prototype.getPublicKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, web3_js_1.PublicKey.createWithSeed(this.context.creator, this.getSeed(), spl_token_1.TOKEN_PROGRAM_ID)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MultisigTokenAccessor.prototype.deserialize = function (pubkey) {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = new spl_token_1.Token(this.context.connection, this.context.mint, spl_token_1.TOKEN_PROGRAM_ID, null // signer is required but isn't used
                        );
                        return [4 /*yield*/, token.getAccountInfo(pubkey)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return MultisigTokenAccessor;
}(accounts_1.AccountAccessor));
exports.MultisigTokenAccessor = MultisigTokenAccessor;
var MultisigTokenAccount = /** @class */ (function (_super) {
    __extends(MultisigTokenAccount, _super);
    function MultisigTokenAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createContext = { space: spl_token_1.AccountLayout.span, owner: "token" };
        return _this;
    }
    MultisigTokenAccount.prototype.getName = function () {
        return "Multisig Token Account";
    };
    MultisigTokenAccount.prototype.getInitInstruction = function () {
        return spl_token_1.Token.createInitAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, this.context.mint, this.pubkey, this.context.creator);
    };
    return MultisigTokenAccount;
}(accounts_1.AccountWithSeed));
exports.MultisigTokenAccount = MultisigTokenAccount;
var DevestingActionAccessor = /** @class */ (function (_super) {
    __extends(DevestingActionAccessor, _super);
    function DevestingActionAccessor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accountConstructor = DevestingActionAccount;
        return _this;
    }
    DevestingActionAccessor.prototype.getSeed = function (params) {
        return (0, utils_1.getSeed)(this.context.programId.toBase58(), "DevestingAction", this.context.vestingName, params.vestingReceiver.toBase58());
    };
    DevestingActionAccessor.prototype.deserialize = function (account) {
        return (0, borsh_1.deserialize)((0, schema_1.generateSchemas)([models_devesting_1.DevestingAction]), models_devesting_1.DevestingAction, account.data);
    };
    DevestingActionAccessor.prototype.getPublicKey = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, web3_js_1.PublicKey.createWithSeed(params.actionCreator, this.getSeed(params), this.context.programId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return DevestingActionAccessor;
}(accounts_1.VestingAccountAccessor));
exports.DevestingActionAccessor = DevestingActionAccessor;
var DevestingActionAccount = /** @class */ (function (_super) {
    __extends(DevestingActionAccount, _super);
    function DevestingActionAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createContext = {
            space: models_devesting_1.DevestingAction.space,
            owner: "program",
        };
        return _this;
    }
    DevestingActionAccount.prototype.getName = function () {
        var _a = this.params[0], actionCreator = _a.actionCreator, vestingReceiver = _a.vestingReceiver;
        return "Devesting Action Account created by ".concat(actionCreator.toBase58(), " for ").concat(vestingReceiver.toBase58());
    };
    return DevestingActionAccount;
}(accounts_1.AccountWithSeed));
exports.DevestingActionAccount = DevestingActionAccount;
var TransferActionAccessor = /** @class */ (function (_super) {
    __extends(TransferActionAccessor, _super);
    function TransferActionAccessor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accountConstructor = TransferActionAccount;
        return _this;
    }
    TransferActionAccessor.prototype.getSeed = function (params) {
        return (0, utils_1.getSeed)(this.context.programId.toBase58(), "MultisigTransferAction", this.context.vestingName, params.index.toString());
    };
    TransferActionAccessor.prototype.deserialize = function (account) {
        return (0, borsh_1.deserialize)((0, schema_1.generateSchemas)([models_devesting_1.TransferAction]), models_devesting_1.TransferAction, account.data);
    };
    TransferActionAccessor.prototype.getPublicKey = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, web3_js_1.PublicKey.createWithSeed(params.actionCreator, this.getSeed(params), this.context.programId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return TransferActionAccessor;
}(accounts_1.VestingAccountAccessor));
exports.TransferActionAccessor = TransferActionAccessor;
var TransferActionAccount = /** @class */ (function (_super) {
    __extends(TransferActionAccount, _super);
    function TransferActionAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createContext = {
            space: models_devesting_1.TransferAction.space,
            owner: "program",
        };
        return _this;
    }
    TransferActionAccount.prototype.getName = function () {
        return "Transfer Action Account";
    };
    return TransferActionAccount;
}(accounts_1.AccountWithSeed));
exports.TransferActionAccount = TransferActionAccount;
//# sourceMappingURL=accounts-devesting.js.map